module.exports = __webpack_public_path__ + "static/media/placeholder.5ded25a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/placeholder.png
// module id = 78
// module chunks = 0